export enum IdType {
    "Passport" = "passport",
    "National ID" = "national id",
    "Foreigner Card" = "foreigner card",
    "RUC" = "ruc"
}